export default __webpack_public_path__ + "static/media/MUST.70b03c88.png";